export const CRUA = {
    wizard: {
        insuranceCoverage: {
            title: 'StoreReady',
        }
    }
};
